export enum Partner {
	MOU_MEDDI = '3',
}
